export default __webpack_public_path__ + "static/sceneario-bedroom-18878aec0f7cb215fda6ca2e420091e1.png";